export enum DEFECT_ESTIMATE_COST_RANGE {
    "custom" = 1,
    "<$1000" = 2,
    "$1000 - $5000" = 3,
    "$5000 - $20000" = 4,
    "$20000 - $50000" = 5,
    "$50000+" = 6,
}
